import React, { useEffect , useState } from 'react'
import { useSelector } from "react-redux";

import footer from '../assets/images/618.png'
import telegram from "../assets/images/telegram.svg"
import instagram from "../assets/images/instagram.svg"
import phone from "../assets/images/phone.svg"


function Footer({config}) {

    const [todayVisitorsState, setTodayVisitorsState] = useState();
    const [yesterdayVisitorsState, setYesterdayVisitorsState] = useState();
    const [totalVisitorsState, setTotalVisitorsState] = useState();
  
    const _yesterdayVisitors = useSelector((state) => state.yesterdayVisitors);
    const _todayVisitors = useSelector((state) => state.todayVisitors);
    const _totalVisitors = useSelector((state) => state.totalVisitors);
  
    useEffect(() => {
      setYesterdayVisitorsState(_yesterdayVisitors);
      setTodayVisitorsState(_todayVisitors);
      setTotalVisitorsState(_totalVisitors);
    }, [_todayVisitors, _yesterdayVisitors, _totalVisitors]);


    return (
        <div className="footer">


                  <img className="footer" src={footer} />
            <div className="social-links">
                <span className="social-item">
                    <span className="icon-social">
                        <img src={telegram} />
                    </span>
                    <span className="link-social">
                        <a href={`https://t.me/${config?.telegram}`}>{config?.telegram}@</a>
                    </span>
                </span>
                <span className="social-item">
                    <span className="icon-social">
                        <img src={instagram} />
                    </span>
                    <span className="link-social">
                        <a href={`https://instagram.com/${config?.instagram}`}>{config?.instagram}@</a>
                    </span>
                </span>
            </div>
            <div className="CopyRight" >
            <p > کلیه حقوق این وب سایت متعلق به شرکت تضامنی صرافی محبوبه اشراقی و شرکا است </p>
           
            </div>
          

          
            <div style={{marginTop:'50 px'}} className="contact-container">
                <div className="contact-item">
                    <span className="contact-icon">
                        <img src={phone} />
                    </span>
                    <span className="contact-info">
                        {config?.phone}
                    </span>
                </div>
                <div className="contact-item">
                </div>
                <div className="contact-item">

          <div style={{display: "flex" }} className=" contact-info screen700:flex">
            <div className="font-normal text-xs screen1000:text-[10px] screen400:text-[9px] screen1800:text-[18px]">
              بازدید امروز :
              <span className="font-semibold mr-1">{todayVisitorsState}</span>
            </div>
            <div style={{margin:'0 7px'}}>
              بازدید دیروز :
              <span className="font-semibold mr-1">
                {yesterdayVisitorsState}
              </span>
            </div>
            <div className="font-normal text-xs screen1000:text-[10px] screen1800:text-[18px] screen400:text-[9px]">
              بازدید کل :
              <span className="font-semibold mr-1">{totalVisitorsState}</span>
            </div>
          </div>
       
                </div>

            </div>
        </div>
    )
}

export default Footer;